import script from "./OTravarPeriodo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTravarPeriodo.vue?vue&type=script&lang=ts&setup=true"

import "./OTravarPeriodo.vue?vue&type=style&index=0&id=9665cc8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9665cc8a"]])

export default __exports__